import dynamic from "next/dynamic";

    const TemkeenComponentHeader = dynamic(() => import(`../components/siteComponents/temkeen/header`), { ssr: false });
    const TemkeenComponentFooter = dynamic(() => import(`../components/siteComponents/temkeen/footer`), { ssr: false });
    const HeroComponent5      = dynamic(() => import(`../components/siteComponents/heros/hero5`), { ssr: false });
    const HeroComponent1      = dynamic(() => import(`../components/siteComponents/heros/hero1`), { ssr: false });
    const HeroComponent2      = dynamic(() => import(`../components/siteComponents/heros/hero2`), { ssr: false });
    const HeroComponent3      = dynamic(() => import(`../components/siteComponents/heros/hero3`), { ssr: false });
    const HeroComponent4      = dynamic(() => import(`../components/siteComponents/heros/hero4`), { ssr: false });
    const HeroComponent6      = dynamic(() => import(`../components/siteComponents/heros/hero6`), { ssr: false });
    const HeroComponent7      = dynamic(() => import(`../components/siteComponents/heros/hero7`), { ssr: false });
    const HeroComponent8      = dynamic(() => import(`../components/siteComponents/heros/hero8`), { ssr: false });
    const HeroComponent9      = dynamic(() => import(`../components/siteComponents/heros/hero9`), { ssr: false });
    const HeroComponent10     = dynamic(() => import(`../components/siteComponents/heros/hero10`), { ssr: false });
    const HeroComponent11     = dynamic(() => import(`../components/siteComponents/heros/hero11`), { ssr: false });
    const AboutComponent1     = dynamic(() => import('../components/siteComponents/about/about1'), { ssr: false });
    const AboutComponent2     = dynamic(() => import('../components/siteComponents/about/about2'), { ssr: false });
    const InfoHeader1         = dynamic(() => import('../components/siteComponents/infoHeader/infoHeader1'), { ssr: false });
    const Banner1             = dynamic(() => import('../components/siteComponents/banners/banner1'), { ssr: false });
    const Banner2             = dynamic(() => import('../components/siteComponents/banners/banner2'), { ssr: false });
    const Banner3             = dynamic(() => import('../components/siteComponents/banners/banner3'), { ssr: false });
    const Banner4             = dynamic(() => import('../components/siteComponents/banners/banner4'), { ssr: false });
    const Banner5             = dynamic(() => import('../components/siteComponents/banners/banner5'), { ssr: false });
    const Banner6             = dynamic(() => import('../components/siteComponents/banners/banner6'), { ssr: false });
    const Banner7             = dynamic(() => import('../components/siteComponents/banners/banner7'), { ssr: false });
    const Banner8             = dynamic(() => import('../components/siteComponents/banners/banner8'), { ssr: false });
    const Banner9             = dynamic(() => import('../components/siteComponents/banners/banner9'), { ssr: false });
    const Contact1            = dynamic(() => import('../components/siteComponents/contact/contact1'), { ssr: false });
    const Contact2            = dynamic(() => import('../components/siteComponents/contact/contact2'), { ssr: false });
    const Ticket1             = dynamic(() => import('../components/siteComponents/ticker/ticker1'), { ssr: false });
    const LayoutGrid          = dynamic(() => import('../components/siteComponents/layout/layoutGrid'), { ssr: false });
    const LayoutFooter        = dynamic(() => import('../components/siteComponents/layout/layoutFooter'), { ssr: false });
    const LayoutFooter1       = dynamic(() => import('../components/siteComponents/layout/layoutFooter1'), { ssr: false });
    const LayoutFooter2       = dynamic(() => import('../components/siteComponents/layout/layoutFooter2'), { ssr: false });
    const Layout1             = dynamic(() => import('../components/siteComponents/layout/layout1'), { ssr: false });
    const Layout2             = dynamic(() => import('../components/siteComponents/layout/layout2'), { ssr: false });
    const Layout3             = dynamic(() => import('../components/siteComponents/layout/layout3'), { ssr: false });
    const Layout4             = dynamic(() => import('../components/siteComponents/layout/layout4'), { ssr: false });
    const Layout5            = dynamic(() => import('../components/siteComponents/layout/layout5'), { ssr: false });
    const Layout6            = dynamic(() => import('../components/siteComponents/layout/layout6'), { ssr: false });
    const Layout7            = dynamic(() => import('../components/siteComponents/layout/layout7'), { ssr: false });
    const Layout8            = dynamic(() => import('../components/siteComponents/layout/layout8'), { ssr: false });
    const Layout9            = dynamic(() => import('../components/siteComponents/layout/layout9'), { ssr: false });
    const ServicesBlock1      = dynamic(() => import('../components/siteComponents/layout/servicesBlock1'), { ssr: false });
    const ColumnLayout        = dynamic(() => import('../components/siteComponents/layout/columnLayout'), { ssr: false });
    const CardLayout          = dynamic(() => import('../components/siteComponents/layout/cardLayout'), { ssr: false });
    const CardRowLayout1      = dynamic(() => import('../components/siteComponents/layout/cardRowLayout1'), { ssr: false });
    const HeroLayout          = dynamic(() => import('../components/siteComponents/heros/herolayout'), { ssr: false });
    const HeroLayout1         = dynamic(() => import('../components/siteComponents/heros/heroLayout1'), { ssr: false });
    const RowLayout           = dynamic(() => import('../components/siteComponents/layout/rowLayout'), { ssr: false });
    const CardRowLayout       = dynamic(() => import('../components/siteComponents/layout/cardRowLayout'), { ssr: false });
    const ProgramGridCard     = dynamic(() => import('../components/siteComponents/categoryPrograms/programGridCard'), { ssr: false });
    const Youtube1            = dynamic(() => import('../components/siteComponents/youtube/youtube1'), { ssr: false });
    const carousel1           = dynamic(() => import('../components/siteComponents/banners/carousel'), { ssr: false })
    const footerInfo2         = dynamic(() => import('../components/siteComponents/footerInfo/footerInfo2'), { ssr: false })
    const VersatileBlock1     = dynamic(() => import('../components/siteComponents/layout/versatileBlock1'), { ssr: false })
    const TeamGridBlock1      = dynamic(() => import('../components/siteComponents/layout/teamGridBlock1'), { ssr: false })
    const TeamCategoryBlock1 = dynamic(() => import('../components/siteComponents/layout/TeamCategoryBlock1'), { ssr: false })
    const FlexibleContentBlock1 = dynamic(() => import('../components/siteComponents/layout/FlexibleContentBlock1'), { ssr: false })


    

     


  
    

    const componentsMap = {
        temkeenHeader : TemkeenComponentHeader,
        temkeenFooter : TemkeenComponentFooter,
        hero5: HeroComponent5,
        hero1: HeroComponent1,
        hero2: HeroComponent2,
        hero3: HeroComponent3,
        hero4: HeroComponent4,
        hero6: HeroComponent6,
        hero7: HeroComponent7,
        hero8: HeroComponent8,
        hero9: HeroComponent9,
        hero10: HeroComponent10,
        hero11: HeroComponent11,
        about1: AboutComponent1,
        about2: AboutComponent2,
        infoheader1:InfoHeader1,
        banner1:Banner1,
        banner2:Banner2,
        banner3:Banner3,
        banner4:Banner4,
        banner5:Banner5,
        banner6:Banner6,
        banner7:Banner7,
        banner8:Banner8,
        banner9:Banner9,
        contact1:Contact1,
        contact2:Contact2,
        ticker1:Ticket1,
        layoutGrid:LayoutGrid,
        layoutFooter:LayoutFooter,
        layoutFooter1:LayoutFooter1,
        layoutFooter2:LayoutFooter2,
        layout1:Layout1,
        layout2:Layout2,
        layout3:Layout3,
        layout4:Layout4,
        layout5:Layout5,
        layout6:Layout6,
        layout7:Layout7,
        layout8:Layout8,
        layout9:Layout9,
        servicesBlock1:ServicesBlock1,
        columnLayout:ColumnLayout,
        cardRowLayout1 : CardRowLayout1,
        heroLayout : HeroLayout,
        heroLayout1 : HeroLayout1,
        cardLayout:CardLayout,
        cardRowLayout:CardRowLayout,
        programGridCard:ProgramGridCard,
        youtube1:Youtube1,
        carousel1:carousel1,
        footerInfo2:footerInfo2,
        versatileBlock1 : VersatileBlock1,
        teamGridBlock1 : TeamGridBlock1,
        teamCategoryBlock1: TeamCategoryBlock1,
        flexibleContentBlock1: FlexibleContentBlock1,

    };

const DynamicHeroWrapper = ({ heroKey }) => {
    // Loop through the keys to find the matching component
    let Component = null;
    for (let i = 0; i <= 20; i++) {
        const heroKeyBase = heroKey.split('.')[0];
        const fullKey = `${heroKeyBase}${i > 0 ? `.${i}` : ''}`;
        
        if (componentsMap[heroKeyBase] && (heroKey === fullKey)) {
            Component = componentsMap[heroKeyBase];
            break;
        }
    }

    return Component ? <Component key={heroKey} heroKey={heroKey} /> : null;
};

export default DynamicHeroWrapper;
